// Manually update this map with brief release notes keyed by the deployed web version.
const releaseNotesMap: Record<string, string[]> = {
  // '1.2.3': ['Short description of the release.'],
  '1.30.0': [
    'New! Rollo Rewards: Earn discounts, perks, and exclusive rewards.',
    'New! Bank payments support.',
    'Improved email templates with multiple recipient support.',
    'Various performance improvements and bug fixes.',
  ],
  '1.31.0': ['Enhanced Rewards experience.', 'Various performance improvements and bug fixes.'],
};

export const getReleaseNotes = (version?: string | null) => {
  if (!version) return null;
  return releaseNotesMap[version] || null;
};

export default releaseNotesMap;
